import React from 'react'
import { Section, Image, Button, Table } from '../../components'
import { ROUTE_PATH, STRING, toastFail } from '../../helpers'
import { ICONS } from '../../themes'
import { TipsAndTutorialEnglishAuctionStyle } from './styled'
import ReactPlayer from 'react-player'
import { TipAndTutorialController } from '../../apiService'
import FileDownload from 'js-file-download'

export class RFQTutorial extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      vdoPlaying: '',
      vdoList: [],
      vdoSelect: 0,
    }
  }

  componentDidMount = async () => {
    await this.getVdoAuctionList()
  }

  getVdoAuctionList = async () => {
    try {
      const res = await TipAndTutorialController().getVdoEnglistAuction(2)
      // console.log(res)
      if (res) {
        if (res.length > 0) {
          this.setState({
            vdoList: res,
            vdoPlaying: res[0].url,
          })
        } else {
          toastFail(res.message)
        }
      }
    } catch (error) {
      throw ('Get VDO RFQ fail', error)
    }
  }

  renderVdoList() {
    const { vdoList } = this.state
    return vdoList.map((item, index) => (
      <div className="guide" key={'vdo' + index}>
        <div
          className={
            this.state.vdoSelect === index
              ? 'guide-custom active'
              : 'guide-custom'
          }
          onClick={() => {
            this.setState({
              vdoPlaying: item.url,
              vdoSelect: index,
            })
          }}
        >
          <div className="guide-info">
            <div className="order">
              {this.state.vdoSelect === index ? (
                <Image
                  className="icon-play"
                  src={ICONS['icon-play-blue.svg']}
                  alt="add icon"
                />
              ) : (
                index + 1 + ' '
              )}
            </div>
            {item.name}
          </div>
          <div className="time-skip">{item.duration}</div>
        </div>
      </div>
    ))
  }

  downloadGuide = async lg => {
    // console.log(lg)
    try {
      const dataFile = await TipAndTutorialController().downloadGuideFile(2, lg)
      if (!dataFile || !dataFile.data) {
        toastFail('Quick guide file is not available')
        return
      }
      FileDownload(dataFile.data, `Quick Guide for RFQ (${lg}).pdf`)
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return (
      <TipsAndTutorialEnglishAuctionStyle>
        {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image src={ICONS['icon-lamp-white.svg']} alt="page icon" />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section className="title">{STRING.RFQ}</Section>

              <Section className="breadcrumbs">
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>{STRING.TIPS_AND_TUTORIAL}</span>
                </Button>
                <Button className="breadcrumb current">
                  <span>{STRING.RFQ}</span>
                </Button>
              </Section>
            </Section>
          </Section>

          <Section className="page-button tip">
            <Button
              className="page-button"
              onClick={() => {
                this.downloadGuide('TH')
              }}
            >
              <Image
                src={ICONS['icon-paper-download-white.svg']}
                alt="add icon"
              />
              <span>Quick Guide for RFQ (TH)</span>
            </Button>

            <Button
              className="page-button"
              onClick={() => {
                this.downloadGuide('EN')
              }}
            >
              <Image
                src={ICONS['icon-paper-download-white.svg']}
                alt="add icon"
              />
              <span>Quick Guide for RFQ (EN)</span>
            </Button>
          </Section>
        </Section>

        {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
        <Section className="main-content">
          <Section className="content-body">
            <Section className="video-wrapper">
              <Section className="vdo">
                <ReactPlayer
                  url={this.state.vdoPlaying}
                  playing={true}
                  width="100%"
                  // height="100%"
                  controls={true}
                  config={{
                    file: {
                      attributes: {
                        controlsList: 'nodownload',
                      },
                    },
                  }}
                />
              </Section>
            </Section>
            <Section className="menu-wrapper">
              <div className="menu">
                <div className="menu-title-wrapper">
                  <div className="menu-title">{STRING.RFQ_TUTORIAL} :</div>
                  <div className="sup-title">
                    Discover Videos -{' '}
                    {this.state.vdoList.length > 0
                      ? this.state.vdoSelect + 1
                      : 0}{' '}
                    / {this.state.vdoList.length}
                  </div>
                </div>
                {this.renderVdoList()}
              </div>
            </Section>
          </Section>
        </Section>
      </TipsAndTutorialEnglishAuctionStyle>
    )
  }
}
